import React, { useEffect, useState, useContext, forwardRef, useImperativeHandle, useRef } from "react";
import * as THREE from "three";
import {
  CSS2DRenderer,
  CSS2DObject,
} from "three/examples/jsm/renderers/CSS2DRenderer.js";
import CameraControls from 'camera-controls';
import loadCachedImage from "../../imageCache.js";
import { PanoContext } from "../../contexts/PanoContextContainer";
import tagPNG from '../../assets/images/tag.svg'
import navArrowUpWhite from "../../assets/images/arrows/icons-arrow-up.svg";
import navArrowDownWhite from "../../assets/images/arrows/icons-arrow-down.svg";
import navArrowLeftWhite from "../../assets/images/arrows/icons-arrow-left.svg";
import navArrowRightWhite from "../../assets/images/arrows/icons-arrow-right.svg";
// import navArrowUpYellow from "../../assets/images/nav_arrow_up_yellow.svg";
// import navArrowLeftYellow from "../../assets/images/nav_arrow_left_yellow.svg";
// import navArrowRightYellow from "../../assets/images/nav_arrow_right_yellow.svg";

import SolutionModal from "../solutionModal";
import ProductModal from "../productModal";
import AudioImageModal from "../components/audioImageModal";
// Old museum images - kept for potential future use
import haritiPanchikaImage from '../../assets/images/Hariti & Panchika.png';
import standingBuddhaImage from '../../assets/images/Standing sculptures of Buddha.png';
import Model3DAudioModal from "../components/model3DAudioModal";
// Note: Old museum audio files removed - not used in new panoramic views
import VideoModal from "../components/videoModal";
import InfoSpotAudioModal from "../components/infoSpotAudioModal";
// import fastingBuddhaModel from '../../assets/Models/Fasting_Buddha.glb'; // Using path string directly if needed, but import is safer for bundlers


import mapIconWhite from '../../assets/svg/map-icon-white.svg'
import mapIconYellow from '../../assets/svg/map-icon-yellow1.svg'
import mapCircle from '../../assets/svg/map-icon-line-white.svg'

import infoInnerWhite from '../../assets/svg/hotspot-inner-white.svg'
import infoOuterWhite from '../../assets/svg/hotspot-outer-white.svg'
import infoInnerYellow from '../../assets/svg/hotspot-inner-yellow.svg'

import "./style.css";

import { TweenMax, Power3 } from 'gsap'

THREE.Cache.enabled = true;
const geometry = new THREE.SphereGeometry(500, 60, 40);
geometry.scale(-1, 1, 1);

let camera, scene, renderer;
let scene2, renderer2, clock, cameraControls;
let moveCamera = "";
let infoPositions = []
let container;
let nre;
let temp;

const preventNativeSelection = (event) => {
  event.preventDefault();
};

const makeHotspotNonSelectable = (element) => {
  if (!element) return;

  element.draggable = false;
  element.addEventListener("dragstart", preventNativeSelection);
  element.addEventListener("selectstart", preventNativeSelection);

  element.querySelectorAll("img").forEach((img) => {
    img.draggable = false;
    img.addEventListener("dragstart", preventNativeSelection);
  });
};

const PanoView = forwardRef((props, ref) => {
  const panoViews = props.tourConfig || [];
  const [selectedView, setSelectedView] = useState(undefined);
  const [solutionModal, showSolutionModal] = useState(undefined);
  const [productModal, showProductModal] = useState(undefined);
  const [audioImageModal, setAudioImageModal] = useState({ show: false, audioSrc: null, srtSrc: null, imageSrc: null });
  const [model3DAudioModal, setModel3DAudioModal] = useState({ show: false, modelUrl: null, audioSrc: null, srtSrc: null });
  const [videoModal, setVideoModal] = useState({ show: false, videoSrc: null, srtSrc: null });
  const [infoSpotAudioModal, setInfoSpotAudioModal] = useState({ show: false, title: '', audioSrc: null, srtSrc: null });
  const { setShowLoader, selected } = useContext(PanoContext);
  const showTransitionNames = props.tourMeta?.showTransitionNames !== false;
  const [bigScreen, setBigScreen] = useState(true)
  const [infoSpotPositions, setInfoSpotPositions] = useState([])
  const [leftNumber, setLeftNumber] = useState(0)
  const [rightNumber, setRightNumber] = useState(0)
  const [sceneReady, setSceneReady] = useState(false)
  const initializedRef = useRef(false);
  const loadedCountRef = useRef(0);
  const activeDownloadsRef = useRef(0);

  function changeScene(i) {
    console.log(i)
    setSelectedView(panoViews[i]);
  }

  function openInfoSpot(i, j) {
    setTimeout(() => {
      let info = panoViews[j].infoSpots[i]
      let modal = (
        <SolutionModal
          show={true}
          closeCallback={closeSolutionModalCallback}
          breadCrum={info.solutionModelData.breadCrum}
          title={info.solutionModelData.title}
          primaryContent={info.solutionModelData.primaryContent}
          productHeadline={info.solutionModelData.productHeadline}
          primaryImage={info.solutionModelData.primaryImage}
          crousalData={info.solutionModelData.crousalData}
          productDetail={info.solutionModelData.productDetail}
          carousalHeadline={info.solutionModelData.carousalHeadline}
          icon={info.solutionModelData.icon}
          changeScene={changeScene}
          openInfoSpot={openInfoSpot}
          infoSpot={info.solutionModelData.infoSpot}
        />
      );
      showSolutionModal(modal);
      let overlay = document.querySelector(".welcome-overlay")
      overlay.style.display = "block"
      overlay.classList.add("modal-overlay")
    }, 300)
  }


  useImperativeHandle(
    ref,
    () => ({
      changeScene(i) {
        setSelectedView(panoViews[i]);
      },

      openInfoSpot(i, j) {
        setTimeout(() => {
          let info = panoViews[j].infoSpots[i]
          let modal = (
            <SolutionModal
              show={true}
              closeCallback={closeSolutionModalCallback}
              breadCrum={info.solutionModelData.breadCrum}
              title={info.solutionModelData.title}
              primaryContent={info.solutionModelData.primaryContent}
              productHeadline={info.solutionModelData.productHeadline}
              primaryImage={info.solutionModelData.primaryImage}
              crousalData={info.solutionModelData.crousalData}
              productDetail={info.solutionModelData.productDetail}
              carousalHeadline={info.solutionModelData.carousalHeadline}
              icon={info.solutionModelData.icon}
              changeScene={changeScene}
              openInfoSpot={openInfoSpot}
              infoSpot={info.solutionModelData.infoSpot}
            />
          );

          showSolutionModal(modal);
          let overlay = document.querySelector(".welcome-overlay")
          overlay.style.display = "block"
          overlay.classList.add("modal-overlay")
        }, 300)
      },


      openProductModal(i, j) {
        setTimeout(() => {
          let info = panoViews[j].infoSpots[i].solutionModelData.productDetail
          let modal = (
            <ProductModal
              show={true}
              closeCallback={closeProductModal}
              closeCrossCallback={closeProductModal}
              productDetail={info}
            />
          );

          showProductModal(modal);
          let overlay = document.querySelector(".welcome-overlay")
          overlay.style.display = "block"
          overlay.classList.add("modal-overlay")
        }, 300)
      },

      closeModel3DAudioModal() {
        setModel3DAudioModal({ ...model3DAudioModal, show: false });
      }


    }),
  )





  useEffect(() => {
    if (!panoViews || panoViews.length === 0) return;

    if (window.innerWidth < 768) {
      setBigScreen(false)
    }
    else {
      setBigScreen(true)
    }

    if (!initializedRef.current) {
      init();
      animate();
      initializedRef.current = true;
      setSceneReady(true);
    }

    // Get the initial selected view index
    const requestedInitialIndex = Number.isInteger(props.initialSceneIndex)
      ? props.initialSceneIndex
      : selected;
    const initialIndex = requestedInitialIndex >= 0 && requestedInitialIndex < panoViews.length
      ? requestedInitialIndex
      : 0;
    const initialView = panoViews[initialIndex];

    // Collect all linked image indices from navigation spots
    const linkedIndices = new Set();
    if (initialView.links && initialView.links.length > 0) {
      initialView.links.forEach(link => {
        linkedIndices.add(link.linkTo);
      });
    }

    // Only preload the initial scene and its directly linked destinations.
    const priorityImages = [];

    panoViews.forEach((view, index) => {
      if (index === initialIndex) {
        priorityImages.unshift({ view, index });
      } else if (linkedIndices.has(index)) {
        priorityImages.push({ view, index });
      }
    });

    let firstImageLoaded = false;
    loadedCountRef.current = 0;

    // Load first image immediately with highest priority
    if (priorityImages.length > 0) {
      const firstImage = priorityImages[0];
      let firstImageCounted = false;

      loadCachedImage(
        firstImage.view.image,
        () => {
          if (!firstImageLoaded) {
            firstImageLoaded = true;
            setSelectedView(panoViews[initialIndex]);
            if (props.setCurrent) {
              props.setCurrent(initialIndex);
            }
            if (cameraControls) {
              cameraControls.reset(false);
              cameraControls.rotate(
                window.innerWidth < 768
                  ? ((panoViews[initialIndex].initialRotation?.[0] || 90) + 25) * THREE.MathUtils.DEG2RAD
                  : ((panoViews[initialIndex].initialRotation?.[0] || 90)) * THREE.MathUtils.DEG2RAD,
                0,
                false
              );
            }
            // Hide loader immediately when first image loads
            setShowLoader(false);
          }
          if (!firstImageCounted) {
            firstImageCounted = true;
            loadedCountRef.current++;
          }
        },
        (event) => {
          if (event.loaded === event.total && !firstImageCounted) {
            firstImageCounted = true;
            loadedCountRef.current++;
          }
        }
      );
    }

    // Preload only a couple of immediately reachable scenes.
    const maxConcurrent = 2;
    activeDownloadsRef.current = 0;
    const downloadQueue = [...priorityImages.slice(1)];
    const loadingSet = new Set(); // Track which images are currently loading to avoid duplicates

    const processQueue = () => {
      while (activeDownloadsRef.current < maxConcurrent && downloadQueue.length > 0) {
        const { view } = downloadQueue.shift();
        const imageUrl = view.image;

        // Skip if already loading or cached
        if (loadingSet.has(imageUrl) || THREE.Cache.get(imageUrl) !== undefined) {
          continue;
        }

        activeDownloadsRef.current++;
        loadingSet.add(imageUrl);
        let imageLoaded = false;

        loadCachedImage(
          imageUrl,
          () => {
            if (!imageLoaded) {
              imageLoaded = true;
              activeDownloadsRef.current--;
              loadingSet.delete(imageUrl);
              loadedCountRef.current++;
              // Process next in queue
              processQueue();
            }
          },
          (event) => {
            if (event.loaded === event.total && !imageLoaded) {
              imageLoaded = true;
              activeDownloadsRef.current--;
              loadingSet.delete(imageUrl);
              loadedCountRef.current++;
              // Process next in queue
              processQueue();
            }
          }
        );
      }
    };

    // Start processing queue after a small delay to let first image start loading
    setTimeout(() => {
      processQueue();
    }, 50);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panoViews, props.initialSceneIndex, props.setCurrent, selected, setShowLoader]);

  useEffect(() => {
    if (!selectedView || !Array.isArray(selectedView.links) || selectedView.links.length === 0) return;

    const linkedViews = selectedView.links
      .map((link) => panoViews[link.linkTo])
      .filter((view) => view?.image);

    linkedViews.slice(0, 2).forEach((view) => {
      if (THREE.Cache.get(view.image) !== undefined) return;

      loadCachedImage(view.image, () => {}, undefined, (error) => {
        console.warn('Linked scene preload failed:', view.image, error);
      });
    });
  }, [panoViews, selectedView]);

  useEffect(() => {
    if (selectedView === undefined || !sceneReady || scene2 == null) return;

    const { setCurrent } = props;
    let hotSpots = [];

    let isActive = true;

    const loadScene = async () => {
      if (scene2 == null) return;

      try {
        const meshAdded = await addPanoViewToScene(selectedView.image, () => isActive);
        if (!meshAdded) return; // aborted because scene changed
      } catch (error) {
        console.error('Failed to load panorama texture:', selectedView.image, error);
        return;
      }

      if (!isActive) return; // Prevent overwriting hotspots of a newer click

      scene2.clear(); // Clear old hotspots at the exact moment the new image is ready to fade in!

      let viewIndex = panoViews.indexOf(selectedView);
      if (viewIndex === -1) viewIndex = 0;

      // Set the camera angle at the exact moment of the fade transition:
      let azimuth = (selectedView.initialRotation?.[0] || 90) * THREE.MathUtils.DEG2RAD;
      let polar = Math.PI / 2 + (selectedView.initialRotation?.[1] || 0) * THREE.MathUtils.DEG2RAD;
      if (viewIndex === 0 && !bigScreen) {
        azimuth = ((selectedView.initialRotation?.[0] || 90) + 25) * THREE.MathUtils.DEG2RAD;
      }
      
      // smoothly rotate to the intended rotation while the crossfade is currently happening
      if (cameraControls.rotateTo) {
        cameraControls.rotateTo(azimuth, polar, true);
      }

      if (selectedView.infoSpots) {
        infoPositions = []
        selectedView.infoSpots.forEach((v) => {
          infoPositions.push({
            pos: new THREE.Vector3(v.position.x, v.position.y, v.position.z),
            name: v.solutionModelData.infoSpot
          })
        })
        setInfoSpotPositions(infoPositions)
        // Add info spots directly since config is self-contained
        selectedView.infoSpots.forEach((spot) => {
          const converted = {
            position: new THREE.Vector3(spot.position.x, spot.position.y, spot.position.z),
            solutionModelData: spot.solutionModelData,
          };
          addInfoPoint(converted);
        });
      }
      else {
        setInfoSpotPositions([])
      }

      // Helper to process links
      const processLink = (link) => {
        let hotSpot = addLinkPoint(link);
        const handleClick = () => {
          setSelectedView(panoViews[link.linkTo])
        };

        hotSpot.addEventListener("click", handleClick);
        hotSpots.push({ element: hotSpot, handler: handleClick });
      };

      if (selectedView.links && selectedView.links.length > 0) {
        selectedView.links.forEach((link) => {
          const converted = {
            name: link.name,
            hotspotRoom: link.hotspotRoom || 'home_automation',
            linkTo: link.linkTo,
            position: new THREE.Vector3(link.position.x, link.position.y, link.position.z),
            scale: new THREE.Vector3(link.scale?.x || 3, link.scale?.y || 3, link.scale?.z || 1),
            rotation: new THREE.Vector3(link.rotation?.x || 0, link.rotation?.y || 0, link.rotation?.z || 0),
          };
          processLink(converted);
        });
      }

      setCurrent(viewIndex);
    };

    loadScene();

    return () => {
      isActive = false;
      hotSpots.forEach(({ element, handler }) => {
        element.removeEventListener("click", handler);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedView, bigScreen, props.setCurrent, sceneReady]);

  const addPanoViewToScene = (url, getIsActive) => {
    return new Promise((resolve, reject) => {
      loadCachedImage(url, (image) => {
        console.log(`[PanoView] Loaded pano image. URL: ${url}, Width: ${image?.width || image?.naturalWidth}`);
        
        if (getIsActive && !getIsActive()) {
          console.log(`[PanoView] Scene changed before image loaded, aborting scene add for: ${url}`);
          resolve(null);
          return;
        }

        if (!image || (image.width === 0 && image.naturalWidth === 0)) {
          console.error(`[PanoView] Critical Error: Loaded image has 0 width! URL: ${url}`);
        }

        let texture = new THREE.Texture();
        texture.image = image;
        texture.needsUpdate = true;
        texture.mapping = THREE.EquirectangularReflectionMapping;
        texture.generateMipmaps = false;
        texture.minFilter = THREE.LinearFilter;
        // Do not set scene.background as it has different spherical mapping than the Mesh
        // and causes a double-rendered flipped image while the Mesh fades in.
        const isFirstScene = scene.children.length === 0;
        const material = new THREE.MeshBasicMaterial({ 
          map: texture, 
          transparent: !isFirstScene, 
          opacity: isFirstScene ? 1 : 0 
        });
        const mesh = new THREE.Mesh(geometry, material);
        scene.add(mesh);
        console.log(`[PanoView] Added mesh to scene. isFirstScene: ${isFirstScene}, Active meshes: ${scene.children.length}`);

        if (isFirstScene) {
          resolve(mesh);
        } else {
          TweenMax.to(material, 1.5, { 
            opacity: 1,
            onComplete: () => {
              console.log(`[PanoView] Tween completed. Removing older meshes for: ${url}`);
              // Remove all older meshes to save memory once the crossfade completes
              while (scene.children.length > 1) {
                if (scene.children[0] !== mesh) {
                  scene.remove(scene.children[0]);
                } else {
                  break;
                }
              }
            }
          });
          resolve(mesh); // Resolve immediately at the exact start of the fade transition
        }
      }, undefined, (error) => {
        console.error(`[PanoView] Error loading cached image for ${url}:`, error);
        reject(error);
      });
    });
  };

  const closeSolutionModalCallback = () => {
    showSolutionModal(undefined);
    // let overlay = document.querySelector(".welcome-overlay")
    // overlay.style.display="none"
    // overlay.classList.remove("modal-overlay")
  };

  const closeProductModal = () => {
    showProductModal(undefined);
    let overlay = document.querySelector(".welcome-overlay")
    overlay.style.display = "none"
    overlay.classList.remove("modal-overlay")
  }

  const addInfoPoint = (info) => {
    let infoSpot = document.createElement("div");
    let namePlate = document.createElement("div")
    let namePlateTag = document.createElement("img")
    let namePlateTag1 = document.createElement("div")
    namePlateTag1.className = "name-plate-tag1"
    namePlateTag.src = tagPNG
    namePlateTag.className = "name-plate-tag"
    namePlate.className = "name-plate"
    let text = document.createElement("p")
    text.innerHTML = info.solutionModelData.infoSpot;
    infoSpot.setAttribute('data-hotspot-type', info.solutionModelData.hotspotType);
    infoSpot.setAttribute('data-hotspot-room', info.solutionModelData.hotspotRoom);
    infoSpot.setAttribute('data-hotspot-product', info.solutionModelData.hotspotProduct);

    text.style.paddingTop = "0px"
    text.style.paddingBottom = "0px"
    text.innerHTML = info.solutionModelData.infoSpot
    namePlateTag1.appendChild(text)
    infoSpot.className = "info-spot-wrap hotspot";

    var animInner = document.createElement("img")
    animInner.style.zIndex = -50
    animInner.className = "infospot-inner-circle"
    animInner.src = infoInnerWhite
    infoSpot.appendChild(animInner)

    var animOuter = document.createElement("img")
    animOuter.className = "infospot-outer-circle"
    animOuter.src = infoOuterWhite
    infoSpot.appendChild(animOuter)

    var animHoverInnerWhite = document.createElement("img")
    animHoverInnerWhite.className = "infospot-hover-inner-circle-white"
    animHoverInnerWhite.src = infoInnerWhite
    animHoverInnerWhite.classList.add("hide")
    infoSpot.appendChild(animHoverInnerWhite)

    var animHoverInnerYellow = document.createElement("img")
    animHoverInnerYellow.className = "infospot-hover-inner-circle-yellow"
    animHoverInnerYellow.src = infoInnerYellow
    animHoverInnerYellow.classList.add("hide")
    infoSpot.appendChild(animHoverInnerYellow)

    var animHoverOuter = document.createElement("img")
    animHoverOuter.className = "infospot-hover-outer-circle"
    animHoverOuter.src = infoOuterWhite
    animHoverOuter.classList.add("hide")
    infoSpot.appendChild(animHoverOuter)

    namePlate.style.pointerEvents = "none"

    namePlate.appendChild(namePlateTag1)
    namePlate.appendChild(namePlateTag)
    infoSpot.appendChild(namePlate)
    makeHotspotNonSelectable(infoSpot);

    if (!bigScreen) {
      animInner.style.display = "none"
      animOuter.style.display = "none"
      animHoverInnerWhite.style.display = "block"
      animHoverInnerYellow.style.display = "block"
      animHoverOuter.style.display = "block"
      TweenMax.to(
        namePlate,
        0.4,
        {
          opacity: 1,
          x: 10,
          display: "block",
          ease: Power3.easeIn()
        }
      )
    }
    else {
      animInner.style.display = "block"
      animOuter.style.display = "block"
      animHoverInnerWhite.style.display = "none"
      animHoverInnerYellow.style.display = "none"
      animHoverOuter.style.display = "none"
      TweenMax.to(
        namePlate,
        0.4,
        {
          opacity: 0,
          x: -10,
          display: "block",
          ease: Power3.easeIn()
        }
      )
    }

    infoSpot.onmouseenter = () => {
      animInner.style.display = "none"
      animOuter.style.display = "none"
      animHoverInnerWhite.style.display = "block"
      animHoverInnerYellow.style.display = "block"
      animHoverOuter.style.display = "block"
      TweenMax.to(
        namePlate,
        0.4,
        {
          opacity: 1,
          x: 10,
          display: "block",
          ease: Power3.easeIn()
        }
      )
    };

    infoSpot.onmouseleave = () => {
      animInner.style.display = "block"
      animOuter.style.display = "block"
      animHoverInnerWhite.style.display = "none"
      animHoverInnerYellow.style.display = "none"
      animHoverOuter.style.display = "none"
      TweenMax.to(
        namePlate,
        0.4,
        {
          opacity: 0,
          x: -10,
          display: "block",
          ease: Power3.easeIn()
        }
      )
    };
    infoSpot.addEventListener("click", () => {
      const data = info.solutionModelData;
      if (data.infoSpotType === 'audioTranscript' && data.audioFile != null) {
        // Resolve the audio folder: prefer data.audioFolder, fall back to tourMeta info VO folders
        let audioFolder = data.audioFolder;
        if (!audioFolder && props.tourMeta) {
          audioFolder = props.tourMeta.infoVoFolderMale || props.tourMeta.infoVoFolderFemale || '';
        }
        const cleanFolder = audioFolder.startsWith('public/') ? audioFolder.substring(7) : (audioFolder.startsWith('public') ? audioFolder.substring(6) : audioFolder);
        const file = data.audioFile;
        setInfoSpotAudioModal({
          show: true,
          title: data.infoSpot,
          audioSrc: `/${cleanFolder}/${file}.mp3`.replace('//', '/'),
          srtSrc: `/${cleanFolder}/${file}.srt`.replace('//', '/'),
        });
        return;
      }
      if (info.solutionModelData.infoSpot === "Miracle of Śrāvastī Info" || info.solutionModelData.infoSpot === "Miracle of Śrāvastī") {
        // Open video player with SRT subtitles
        setVideoModal({
          show: true,
          videoSrc: '/1. The Miracles at Śrāvastī.mp4',
          srtSrc: '/1. The Miracles at Śrāvastī.srt'
        });
      } else if (info.solutionModelData.infoSpot === "Hariti & Panchika info" || info.solutionModelData.infoSpot === "Hariti & Panchika") {
        // Open audio player with animated image
        // To use new audio: add MP3 to public/audio/info-spots/ and set audioSrc: `${INFO_SPOT_AUDIO_URL}/filename.mp3`
        setAudioImageModal({
          show: true,
          audioSrc: null, // haritiPanchikaAudio - file no longer exists
          srtSrc: '/Hariti & Panchika.srt',
          imageSrc: haritiPanchikaImage
        });
      } else if (info.solutionModelData.infoSpot === "Standing sculptures of Buddha Info" || info.solutionModelData.infoSpot === "Standing sculptures of Buddha") {
        // Open audio player with animated image for Standing sculptures of Buddha
        // Note: Old museum content - audio file removed
        setAudioImageModal({
          show: true,
          audioSrc: null, // standingBuddhaAudio - file no longer exists
          srtSrc: '/Images of the Buddha in Gandhara Art.srt',
          imageSrc: standingBuddhaImage
        });
      } else if (info.solutionModelData.infoSpot === "Fasting Siddhartha") {
        // Open 3D model with audio
        // Note: Old museum content - audio file removed
        setModel3DAudioModal({
          show: true,
          modelUrl: '/Fasting_Buddha.glb', // Assuming it's in public folder or handled by loader
          audioSrc: null, // fastingBuddhaAudio - file no longer exists
          srtSrc: '/3. The Fasting Siddhartha.srt' // Assuming it's in public folder
        });
      } else {
        // Default behavior: open SolutionModal
        let modal = (
          <SolutionModal
            show={true}
            closeCallback={closeSolutionModalCallback}
            breadCrum={info.solutionModelData.breadCrum}
            title={info.solutionModelData.title}
            primaryContent={info.solutionModelData.primaryContent}
            productHeadline={info.solutionModelData.productHeadline}
            primaryImage={info.solutionModelData.primaryImage}
            crousalData={info.solutionModelData.crousalData}
            productDetail={info.solutionModelData.productDetail}
            carousalHeadline={info.solutionModelData.carousalHeadline}
            icon={info.solutionModelData.icon}
            changeScene={changeScene}
            openInfoSpot={openInfoSpot}
            infoSpot={info.solutionModelData.infoSpot}
          />
        );
        showSolutionModal(modal);
      }
      // let overlay = document.querySelector(".welcome-overlay")
      // overlay.style.display="block"
      // overlay.classList.add("modal-overlay")
    });
    let object = new CSS2DObject(infoSpot);
    object.position.copy(info.position);

    if (info.scale) object.scale.copy(info.scale);

    if (info.rotation) {
      object.rotation.x = info.rotation.x;
      object.rotation.y = info.rotation.y;
      object.rotation.z = info.rotation.z;
    }

    scene2.add(object);
    scene2.add(nre)



    return infoSpot;
  };

  const addLinkPoint = (link) => {
    let hotSpot = document.createElement("div");
    let namePlate = null;
    if (showTransitionNames) {
      namePlate = document.createElement("div");
      let namePlateTag = document.createElement("img");
      namePlateTag.src = tagPNG;
      namePlateTag.className = "name-plate-tag";
      namePlate.className = "name-plate";
      let namePlateTag1 = document.createElement("div");
      namePlateTag1.className = "name-plate-tag1";
      let text = document.createElement("p");
      text.style.paddingTop = "0px";
      text.style.paddingBottom = "0px";
      text.innerHTML = link.name;
      namePlateTag1.appendChild(text);
      namePlate.appendChild(namePlateTag1);
      namePlate.appendChild(namePlateTag);
      hotSpot.appendChild(namePlate);
    }
    hotSpot.className = "hotspot";
    hotSpot.setAttribute('data-hotspot-type', 'location')
    hotSpot.setAttribute('data-hotspot-room', link.hotspotRoom)
    var anim = document.createElement("img")
    anim.className = "vert-move-white"
    anim.src = mapIconWhite
    hotSpot.appendChild(anim)

    var animHover = document.createElement("img")
    animHover.className = "vert-move-yellow hotspot"
    animHover.setAttribute('data-hotspot-type', 'location')
    animHover.setAttribute('data-hotspot-room', link.hotspotRoom)
    animHover.classList.add("hide")
    animHover.src = mapIconYellow
    hotSpot.appendChild(animHover)

    var animHoverCircle = document.createElement("img")
    animHoverCircle.className = "map-circle"
    animHoverCircle.classList.add("hide")
    animHoverCircle.src = mapCircle
    hotSpot.appendChild(animHoverCircle)
    makeHotspotNonSelectable(hotSpot);

    if (showTransitionNames && !bigScreen) {
      anim.style.display = "none"
      animHover.style.display = "block"
      animHoverCircle.style.display = "block"
      TweenMax.to(
        namePlate,
        0.4,
        {
          opacity: 1,
          x: 10,
          display: "block",
          ease: Power3.easeIn()
        }
      )
    }
    else {
      anim.style.display = "block"
      animHover.style.display = "none"
      animHoverCircle.style.display = "none"
      if (showTransitionNames) {
        TweenMax.to(
          namePlate,
          0.4,
          {
            opacity: 0,
            x: -10,
            display: "none",
            ease: Power3.easeOut()
          }
        )
      }
    }

    hotSpot.onmouseenter = async () => {
      anim.style.display = "none"
      animHover.style.display = "block"
      animHoverCircle.style.display = "block"
      if (showTransitionNames) {
        TweenMax.to(
          namePlate,
          0.4,
          {
            opacity: 1,
            x: 10,
            display: "block",
            ease: Power3.easeIn()
          }
        )
      }
    };
    hotSpot.onmouseleave = async () => {
      anim.style.display = "block"
      animHover.style.display = "none"
      animHoverCircle.style.display = "none"
      if (showTransitionNames) {
        TweenMax.to(
          namePlate,
          0.4,
          {
            opacity: 0,
            x: -10,
            display: "none",
            ease: Power3.easeOut()
          }
        )
      }

    };

    let object = new CSS2DObject(hotSpot);
    object.position.copy(link.position);

    if (link.scale) object.scale.copy(link.scale);

    if (link.rotation) {
      object.rotation.x = link.rotation.x;
      object.rotation.y = link.rotation.y;
      object.rotation.z = link.rotation.z;
    }

    scene2.add(object);
    return hotSpot;
  };

  function init() {
    container = document.getElementById("infoContainer");
    camera = new THREE.PerspectiveCamera(
      60,
      window.innerWidth / window.innerHeight,
      1,
      10000
    );
    camera.position.z = 0.01;
    camera.fov = THREE.MathUtils.clamp(100, 10, 75)
    camera.updateProjectionMatrix();

    scene = new THREE.Scene();
    scene2 = new THREE.Scene();

    renderer = new THREE.WebGLRenderer();
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.domElement.style.zIndex = 2;
    renderer.domElement.style.flex = "1 1 auto";
    renderer.domElement.style.overflow = "hidden";

    container.appendChild(renderer.domElement);
    container.style.touchAction = "none";
    container.addEventListener("pointerup", onPointerUp, false);
    container.addEventListener("pointerup", onPointerDown, false);

    renderer2 = new CSS2DRenderer();
    renderer2.setSize(window.innerWidth, window.innerHeight);
    renderer2.domElement.style.position = "absolute";
    renderer2.domElement.style.top = 0;
    renderer2.domElement.style.zIndex = 4;
    container.appendChild(renderer2.domElement);
    var test = document.createElement("div")
    test.className = "test-div"
    test.innerHTML = `Bilal`
    nre = new CSS2DObject(test);
    clock = new THREE.Clock();
    const EPS = 1e-5;
    CameraControls.install({ THREE: THREE });
    cameraControls = new CameraControls(camera, renderer2.domElement);
    cameraControls.azimuthRotateSpeed = - 0.2; // negative value to invert rotation direction
    cameraControls.polarRotateSpeed = - 0.2; // negative value to invert rotation direction
    cameraControls.truckSpeed = 1 / EPS * 3;
    cameraControls.mouseButtons.right = CameraControls.ACTION.NONE
    cameraControls.mouseButtons.wheel = CameraControls.ACTION.NONE
    document.addEventListener("wheel", onDocumentMouseWheel, false);
    window.addEventListener("resize", onWindowResize, false);
  }

  function onWindowResize() {
    // camera.updateProjectionMatrix();
    // renderer.setSize(window.innerWidth, window.innerHeight);
    // renderer2.setSize(window.innerWidth, window.innerHeight);
    if (window.innerWidth < 768) {
      setBigScreen(false)
    }
    else {
      setBigScreen(true)
    }
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer2.setSize(window.innerWidth, window.innerHeight);
    renderer.setSize(window.innerWidth, window.innerHeight);

  }

  function onPointerDown(event, allPositions) {
    if (event.isPrimary === false)
      return;
    document.addEventListener("pointerup", (e) => onPointerUp(e, allPositions), false);
    // updateNavigation(allPositions)
  }

  function onPointerUp(event, allPositions) {
    if (event.isPrimary === false) return;
    document.removeEventListener("pointerup", onPointerUp);
    moveCamera = ""
    // updateNavigation(allPositions)
  }

  function onDocumentMouseWheel(event) {
    // Wheel handler - functionality commented out
    // if (!!!modal && !!!attachmentModal && !!!solutionModal && mapModal.classList[1]=="fadeOut" && overlay.style.display=='none' && !sidebar.classList.contains("is-open") && filterResults==null && getInTouch.style.display=="none" && filter==null) {
    //   const fov = camera.fov + event.deltaY * 0.05;
    //   if (fov < 50) return;
    //   camera.fov = THREE.MathUtils.clamp(fov, 10, 75);
    //   camera.updateProjectionMatrix();
    // }
  }

  const updateCameraLookAt = () => {
    if (moveCamera === "left") {
      cameraControls.rotate(1 * THREE.MathUtils.DEG2RAD, 0, true)
    }
    else if (moveCamera === "right") {
      cameraControls.rotate(-1 * THREE.MathUtils.DEG2RAD, 0, true)
    }
    else if (moveCamera === "top") {
      cameraControls.rotate(0, 1 * THREE.MathUtils.DEG2RAD, true)
    }
    else if (moveCamera === "down") {
      cameraControls.rotate(0, -1 * THREE.MathUtils.DEG2RAD, true)
    }
  };

  function animate() {
    requestAnimationFrame(animate);
    updateCameraLookAt();
    updateNavigation(infoPositions);
    const delta = clock.getDelta();
    cameraControls.update(delta);
    camera.updateMatrix();
    camera.updateMatrixWorld();
    // object.position.set(new THREE.Vector3(-400, -100, 750))
    renderer.render(scene, camera);
    renderer2.render(scene2, camera);
  }

  const updateNavigation = (allPositions) => {
    camera.updateMatrix();
    camera.updateMatrixWorld();
    var frustum = new THREE.Frustum();
    frustum.setFromProjectionMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));
    // Your 3d point to check
    var left = 0
    var right = 0
    allPositions.forEach(v => {
      if (!frustum.containsPoint(v.pos)) {
        temp = v.pos.clone();
        camera.worldToLocal(temp);
        if (temp.x < 0) {
          left = left + 1
        }
        else {
          right = right + 1
        }
      }
      setLeftNumber(left)
      setRightNumber(right)
    })
  }


  return (
    <div id="infoContainer">
      <div id="navArrows">
        <img
          src={navArrowUpWhite}
          className="img-arrow img-arrow-up"
          draggable="false"
          onContextMenu={event => event.preventDefault()}
          // onMouseEnter={(e) => {e.target.src=navArrowUpYellow}}
          // onMouseLeave={(e) => {e.target.src=navArrowUpWhite}}
          onTouchStart={(e) => { e.preventDefault(); moveCamera = "top" }}
          onTouchEnd={(e) => { e.preventDefault(); moveCamera = "" }}
          onPointerDown={(e) => { e.preventDefault(); moveCamera = "top" }}
          onPointerUp={(e) => { e.preventDefault(); moveCamera = "" }}
          alt="Nav Arrow Up"
        />
        <img
          src={navArrowDownWhite}
          onContextMenu={event => event.preventDefault()}
          className="img-arrow img-arrow-down"
          draggable="false"
          // onMouseEnter={(e) => {e.target.src=navArrowUpYellow}}
          // onMouseLeave={(e) => {e.target.src=navArrowUpWhite}}
          onTouchStart={(e) => { e.preventDefault(); moveCamera = "down" }}
          onTouchEnd={(e) => { e.preventDefault(); moveCamera = "" }}
          onPointerDown={(e) => { e.preventDefault(); moveCamera = "down" }}
          onPointerUp={(e) => { e.preventDefault(); moveCamera = "" }}
          alt="Nav Arrow Down"
        />
        <img
          src={navArrowLeftWhite}
          onContextMenu={event => event.preventDefault()}
          className="img-arrow img-arrow-left"
          draggable="false"
          // onMouseEnter={(e) => {e.target.src=navArrowLeftYellow}}
          // onMouseLeave={(e) => {e.target.src=navArrowLeftWhite}}
          onTouchStart={(e) => { e.preventDefault(); moveCamera = "left" }}
          onTouchEnd={(e) => { e.preventDefault(); moveCamera = "" }}
          onPointerDown={(e) => { e.preventDefault(); moveCamera = "left" }}
          onPointerUp={(e) => { e.preventDefault(); moveCamera = "" }}
          alt="Nav Arrow Left"
        />
        {infoSpotPositions.length > 0 && <p className="img-arrow img-arrow-left-text">{leftNumber} Hotspots</p>}
        <img
          src={navArrowRightWhite}
          className="img-arrow img-arrow-right"
          draggable="false"
          onContextMenu={event => event.preventDefault()}
          // onMouseEnter={(e) => {e.target.src=navArrowRightYellow}}
          // onMouseLeave={(e) => {e.target.src=navArrowRightWhite}}
          onTouchStart={(e) => { e.preventDefault(); moveCamera = "right" }}
          onTouchEnd={(e) => { e.preventDefault(); moveCamera = "" }}
          onPointerDown={(e) => { e.preventDefault(); moveCamera = "right" }}
          onPointerUp={(e) => { e.preventDefault(); moveCamera = "" }}
          alt="Nav Arrow Right"
        />
        {infoSpotPositions.length > 0 && <p className="img-arrow img-arrow-right-text">{rightNumber} Hotspots</p>}
      </div>
      {/* {cookiePopup && 
    <div className="cookie-overlay">
    <div className="accept-cookie custom-container">
        <p className="cookie-desc">
        Important information regarding the Hajj Application website: this site uses cookies to improve user experience and stores information on your computer. By continuing to use our site, you consent to our Cookie Policy. If you do not want to enable cookies, review our policy and learn how they can be disabled. Note that disabling cookies will disable some features of the site.
        </p>
        <button className="accept-button" onClick={acceptCookies}>ACCEPT</button>
        </div>
        </div>
        } */}
      {solutionModal}
      {productModal}
      <AudioImageModal
        show={audioImageModal.show}
        onClose={() => setAudioImageModal({ ...audioImageModal, show: false })}
        audioSrc={audioImageModal.audioSrc}
        srtSrc={audioImageModal.srtSrc}
        imageSrc={audioImageModal.imageSrc}
      />

      <Model3DAudioModal
        show={model3DAudioModal.show}
        onClose={() => setModel3DAudioModal({ ...model3DAudioModal, show: false })}
        modelUrl={model3DAudioModal.modelUrl}
        audioSrc={model3DAudioModal.audioSrc}
        srtSrc={model3DAudioModal.srtSrc}
      />

      <VideoModal
        show={videoModal.show}
        onClose={() => setVideoModal({ ...videoModal, show: false })}
        videoSrc={videoModal.videoSrc}
        srtSrc={videoModal.srtSrc}
      />

      <InfoSpotAudioModal
        show={infoSpotAudioModal.show}
        onClose={() => setInfoSpotAudioModal({ ...infoSpotAudioModal, show: false })}
        title={infoSpotAudioModal.title}
        audioSrc={infoSpotAudioModal.audioSrc}
        srtSrc={infoSpotAudioModal.srtSrc}
      />
    </div>
  );
})

export default PanoView;
